import { render, staticRenderFns } from "./ListaTransportadoras.vue?vue&type=template&id=fc8a83e0"
import script from "./ListaTransportadoras.vue?vue&type=script&lang=js"
export * from "./ListaTransportadoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports